import React, { useState, useEffect, Fragment } from "react";
import localization from "assets/localization/localization";
import Layout from "components/sales/layout/layout";
import { Button } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "../../vendorPortal/viewVendorDetail/ViewVendorDetail.css";

const ViewBusinessItem = ({ getBusinessItemList, businessItemData, approveItemRequest, updateItemRequest }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { id, type } = useParams();

  const role_id = window.localStorage.getItem("fusion-role");

  useEffect(() => {
    if (getBusinessItemList && id) {
      (async () => {
        setIsLoading(true);
        await getBusinessItemList(null, type, 1, id);
        setIsLoading(false);
      })();
    }
  }, [id, type]);

  const renderRow = (label, value) => (
    <div className="detail-item" key={label}>
      <span className="label">{label}</span>
      <span className="value">
        {value !== null && value !== undefined && value !== ""
          ? value.toString()
          : "N/A"}
      </span>
    </div>
  );

  const renderObject = (obj, title) => (
    <div className="details-card">
      <div className="details-card-header">{title}
      </div>
      <div className="details-card-body">
        {Object.entries(obj).map(([key, val]) => renderRow(formatLabel(key), val))}
      </div>
    </div>
  );

  const formatLabel = (str) =>
    str
      .replace(/_/g, " ")
      .replace(/\b\w/g, (l) => l.toUpperCase());

  const isMaterial = type === "M";

  const approveItem = async (status) => {
    try {
      setIsLoading(true);

      const isPending = isMaterial 
        ? (businessItemData.material_status === 'Pending Approve' || businessItemData.material_status == 1) 
        : businessItemData.service_status === 1;

      const isApproved = isMaterial 
        ? (businessItemData.material_status === 'Approved' || businessItemData.material_status == 2) 
        : businessItemData.service_status === 2;

      let payload = {
        id,
        type,
      };

      if (isPending) {
        payload.approval_status = status;
      }

      if (isApproved && status === 'APPROVE') {
        payload.is_edit_request = 0;
        payload.is_edit_request_approved = 1;
        payload.type = type=='S' ? 'Service' : 'Inventory';
      }

      else if (isApproved && status === 'REJECT') {
        payload.is_edit_request = 0;
        payload.is_edit_request_approved = 2;
        payload.type = type=='S' ? 'Service' : 'Inventory';
      }

      const res = isApproved ? await updateItemRequest(payload) : await approveItemRequest(payload);
      if (res?.data?.status === true) {
        toast.success(res?.data?.message || "Item approved successfully!");
        window.history.back();
      } else {
        toast.error(res?.data?.message || "Failed to approve item");
      }
    } catch (error) {
      console.error("Error while approving item:", error);
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const headerBtns = () => {
    const isPending = businessItemData.material_status == 'Pending Approve' || businessItemData.service_status == 1;
    const isEditApproval = businessItemData.is_edit_request_approval == 1;

    return (
      <Fragment>
        {isPending && (
          <>
            <Button
              onClick={() => approveItem('APPROVE')}
              className="filter-hamburger btn btn-transparent"
            >
              {isEditApproval ? 'Approve Edit Request' : 'Approve'}
            </Button>

            <Button
              onClick={() => approveItem('REJECT')}
              className="filter-hamburger btn btn-transparent"
            >
              {isEditApproval ? 'Reject Edit Request' : 'Reject'}
            </Button>
          </>
        )}

        {!isPending && isEditApproval && (
          <>
            <Button
              onClick={() => approveItem('APPROVE')}
              className="filter-hamburger btn btn-transparent"
            >
              Approve Edit Request
            </Button>

            <Button
              onClick={() => approveItem('REJECT')}
              className="filter-hamburger btn btn-transparent"
            >
              Reject Edit Request
            </Button>
          </>
        )}
      </Fragment>
    );
  };

  return (
    <Layout
      title={localization.BacktoList}
      isLoading={isLoading}
      isGoback
      Buttons={role_id == 11 ? headerBtns: ''}
    >
      {businessItemData && (
        <div className="vendor-details-wrapper">
          {/* Header Card */}
          <div className="details-card">
            <div className="details-card-header">
              {isMaterial ? "Material Details" : "Service Details"}
            </div>
            <div className="details-card-body">
              {renderRow("ID", businessItemData.id)}
              {renderRow(
                "Status",
                businessItemData.status === 1 || businessItemData.status === "1"
                  ? "Active"
                  : "Inactive"
              )}
              {renderRow("HSN Code", businessItemData.hsn_code)}
              {renderRow("GST Code", `${businessItemData.gst_name}`)}
              {renderRow("Approval Status", `${businessItemData.show_status}`)}
              {businessItemData.remarks &&
                renderRow("Remarks", businessItemData.remarks)}
              {isMaterial
                ? renderRow("Item Type", businessItemData.item_type)
                : renderRow("Recon Service ID", businessItemData.recon_service_id)}
            </div>
          </div>

          {/* Dynamic Sections */}
          {isMaterial ? (
            <>
              {renderObject(
                {
                  material_name: businessItemData.material_name,
                  category: businessItemData.category,
                  material_class: businessItemData.material_class,
                  brand_name: businessItemData.brand_name,
                  uom: businessItemData.uom,
                  sale_value: businessItemData.sale_value,
                  cost_price: businessItemData.cost_price,
                  description: businessItemData.description,
                  created_by: businessItemData.created_by,
                  updated_by: businessItemData.updated_by,
                  created_at: businessItemData.created_at,
                  updated_at: businessItemData.updated_at,
                },
                "Material Info"
              )}

              {businessItemData.meta_details &&
                renderObject(businessItemData.meta_details, "Meta Details")}
            </>
          ) : (
            <>
              {renderObject(
                {
                  service_name:
                  businessItemData.service_name || businessItemData.name,
                  service_code: businessItemData.service_code,
                  category: businessItemData.category,
                  brand_name: businessItemData.brand_name,
                  description: businessItemData.description,
                  uom: businessItemData.uom,
                  service_category_id: businessItemData.service_category_id,
                  base_price: businessItemData.base_price,
                  revenue_type: businessItemData.revenue_type,
                  created_at: businessItemData.created_at,
                  updated_at: businessItemData.updated_at,
                },
                "Service Info"
              )}

              {businessItemData.meta_details &&
                renderObject(businessItemData.meta_details, "Meta Details")}
            </>
          )}
        </div>
      )}
    </Layout>
  );
};

export default ViewBusinessItem;